<template>
  <fb-main-body>
    <el-card>
      <el-descriptions :column="1" :title="$t('lang.基础信息')" class="desc-box">
        <el-descriptions-item labelStyle="display: none">
          <el-image :src="detailInfo['productPhotoCode'] | filterImg(that)" style="height: 200px; width: 200px"></el-image>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.SN码')">{{ detailInfo['sn'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.品牌')">{{ detailInfo['brandOwnerName'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.子品牌')">{{ detailInfo['subBrandName'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.型号')">{{ detailInfo['productModel'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.子型号')">{{ detailInfo['productSubModel'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.产品名称')">{{ detailInfo['productName'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.激活日期')">{{ detailInfo['activeDate'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.APK版本')">{{ detailInfo['apkEdition'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.MCU版本')">{{ detailInfo['mcuVersion'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.TP版本')">{{ detailInfo['tpVersion'] }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions :column="3" :title="$t('lang.用户信息')" class="desc-box">
        <el-descriptions-item :label="$t('lang.地区')">{{ detailInfo['countryName'] }}/{{ detailInfo['provinceName'] }}/{{ detailInfo['cityName'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.账户')">{{ detailInfo['userAccount'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.注册时间')">{{ detailInfo['userCreateTimeStr'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.昵称')">{{ detailInfo['userNickname'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.性别')">{{detailInfo['userGenderName']}}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.年龄')">{{ detailInfo['userAge'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.头像')">
          <el-image :src="detailInfo['userPortrait'] | filterImg(that)" style="height: 100px; width: 100px"></el-image>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions :column="3" :title="$t('lang.联网信息')" class="desc-box">
        <el-descriptions-item :label="$t('lang.联网状态')">{{detailInfo['onlineStatusName']}}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.联网IP')">{{ detailInfo['ip'] }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.最后联网时间')">{{detailInfo['lastOnlineTimeStr']}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </fb-main-body>
</template>

<script>

export default {
  name: "deviceInfoDetail",
  components: {},
  data() {
    return {
      api: {
        detail: this.$api.device.detail,
      },

      detailInfo: {},
      that: this,
    }
  },
  methods: {

  },

  created() {

    let vm = this;
    this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
      if(resp.data.status != 200) {
        vm.$message.error(resp.data.desc);
        return;
      }

      vm.detailInfo = resp.data.data['device'];

    });

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}

.desc-box {
  margin-bottom: 34px;
}


</style>
